import { coordinateFormats } from '@gmn-portal/backend';
import { z } from 'zod';

export const userFormSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  language: z.enum(['de-DE', 'en-US']),
  coordinateFormatPreference: z.enum(coordinateFormats),
  themeMode: z.enum(['light', 'dark', 'system']),
});
